import { Locale } from 'src/types'

import localeService from 'src/api/localeService'

import {
  Comparator,
  ListOfSortsState,
  SortStates,
} from 'src/pages/ServiceContactsHistory/types'

export const getListOfSortsStates = (
  locale: Locale['serviceContacts']['historyServiceContacts'],
): ListOfSortsState[] => {
  const { byNew, byAlphabet } = locale.sortStates

  return [
    {
      type: SortStates.BY_NEW,
      title: byNew,
    },
    {
      type: SortStates.BY_ALPHABET,
      title: byAlphabet,
    },
  ]
}

export const handleSortChange = (sortState: SortStates): Comparator => {
  switch (sortState) {
    case SortStates.BY_ALPHABET:
      return (a, b) => {
        const nameA = a.contactName.toLowerCase()
        const nameB = b.contactName.toLowerCase()

        return nameA.localeCompare(nameB)
      }

    default:
      throw new Error(
        `${localeService.translation.fireBaseErrors.unsupportedError}: ${sortState}`,
      )
  }
}
